module.exports = __webpack_public_path__ + "img/white_dance.9b9163cf.png";